import { createSVGConfig, SVGSourceData } from "./svg-config";

interface HeadingLine {
  heading: string;
}

interface TextLine {
  label: string;
  text: string | number;
}

interface ImageLine {
  src: string;
}

export type SVGLine = HeadingLine | TextLine | ImageLine;

interface DrawSVGProps {
  heading: string;
  lines: SVGLine[];
}
function drawSVG({ heading, lines }: DrawSVGProps) {
  let y = 20;
  const yIncr = 20;
  const tab1 = 5;
  const tab2 = 10;
  const tab3 = 150;
  const imgHeight = 200;

  const svg = [
    `<text font-weight="bold" font-size="large" x="${tab1}" y="${y}">${heading}</text>`,
  ];
  y += yIncr;
  let headingLast = false;

  for (const rec of lines) {
    if ("heading" in rec) {
      if (headingLast) {
        // If the last was a heading, indicates empty content
        svg.pop();
        y -= 2 * yIncr;
      }

      y += yIncr;
      svg.push(
        `<text font-weight="bold" x="${tab1}" y="${y}">${
          (rec as HeadingLine).heading
        }</text>`
      );
      y += yIncr;
      headingLast = true;
    } else if ("src" in rec) {
      svg.push(
        `<image height="${imgHeight}" x="${tab2}" y="${y}" href="${
          (rec as ImageLine).src
        }" />`
      );
      y += imgHeight;
      headingLast = false;
    } else {
      const { text } = rec as TextLine;
      if (text) {
        const safeText = text.toString().replace(/\r?\n/g, " ");
        svg.push(
          `<text x="${tab2}" y="${y}">${(rec as TextLine).label}</text>`
        );
        svg.push(`<text x="${tab3}" y="${y}">${safeText}</text>`);
        y += yIncr;
        headingLast = false;
      }
    }
  }

  svg.push("</svg>");
  svg.unshift(
    `<svg xmlns="http://www.w3.org/2000/svg" xml:lang="en" height="${
      y + yIncr
    }" width="500">`
  );

  return svg.join("");
}

export function createSVG({ lines, heading }: DrawSVGProps) {
  return drawSVG({ lines, heading });
}

export function createText({ lines, heading }: DrawSVGProps) {
  const initial = `${heading}\n`;
  return lines.reduce((accumulator, currentLine) => {
    if ("heading" in currentLine) {
      return `${accumulator}\n${currentLine.heading}:\n`;
    }
    if ("label" in currentLine && "text" in currentLine) {
      const { label, text } = currentLine;
      return `${accumulator}${label}: ${text}\n`;
    }
    return accumulator;
  }, initial);
}

export function createSVGNew({
  heading,
  data,
}: {
  heading: string;
  data: SVGSourceData;
}) {
  const lines = createSVGConfig(data);

  const svg = drawSVG({
    lines,
    heading,
  });

  return svg;
}
